<template>
  <div class="outbig_box">

    <div class="navbox">
      <div class="grid-content bg-purple" style="display: flex;justify-content: space-around;">
         <!-- <img src="../../assets/平台LOGO.png" alt="" style="height: 32px ;margin-right:10px"> -->
         <img src="../../assets/平台LOGO.png" alt="" style="height: 32px ;margin-right:10px">
           <span
          style="line-height: 72px;font-size: 20px;white-space: nowrap;color: #fff;">XR资源管理平台</span><span></span></div>
      <el-menu :default-active="this.$route.path" router background-color="transparent" class="el-menu-demo"
        text-color="#fff" active-text-color="#fff" style="height:72px;" mode="horizontal">
        <el-menu-item index="/homepage" v-if=" roles != 'student' && roles != '学生'&& roles != 'visiter'">
          <i class="iconfont icon-shouye" style="margin-right: 5px;"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/shouye" v-if=" roles != 'student' && roles != '学生'&& roles != 'visiter'"
          :class="{ active: isActive == '/shouye' || isActive == '/bianji' || isActive == '/tongji' || isActive == '/jilu' || isActive == '/shiyan' || isActive == '/expbianji' }">
          <i v-if=" roles != 'student' && roles != '学生'" class="iconfont icon-shiyan" style="margin-right: 5px;"></i>
          <span slot="title" v-if="roles != 'student' && roles != '学生' && roles != 'visiter'">实验中心</span>
          <span slot="title" v-if=" roles == 'visiter'">实验课程</span>
        </el-menu-item>
        <el-menu-item index="/videopage" v-if=" roles != 'student' && roles != '学生'&& roles != 'visiter'"
          :class="{ active: isActive == '/videob' || isActive == '/videox' || isActive == '/online' || isActive == '/videoc' }">
          <i v-if=" roles != 'student' && roles != '学生'" class="iconfont icon-shipin" style="margin-right: 5px;"></i>
          <span slot="title" v-if="roles != 'student' && roles != '学生' && roles != 'visiter'">课程中心</span>
          <span slot="title" v-if=" roles == 'visiter'">在线课程</span>
        </el-menu-item>
        <el-submenu index="5" :class="{ active: isActive == '/Resour' || isActive == '/videor' }"
          v-if="roles != 'student' && roles != '学生' && roles != 'visiter'" class="noborder">
          <template slot="title">
            <i class="iconfont icon-guizewendang" style="margin-right: 5px;"></i>
            <span>资源中心</span>
          </template>
          <el-menu-item-group style=" background: rgba(250, 250, 250, 1);  width: 166px;">
            <el-menu-item index="/Resources" style="color: #333;">实验资源</el-menu-item>
            <el-menu-item index="/videores" style="color: #333;">课程资源</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2"
          :class="{ active: isActive == '/myclas' || isActive == '/tiKu' || isActive == '/tiKu' || isActive == '/shijua' || isActive == '/kaoshi' || isActive == '/chengj' }"
          v-if="roles != 'student' && roles != '学生' && roles != 'visiter'" class="noborder">
          <template slot="title">
            <i class="iconfont icon-renyuan-" style="margin-right: 5px;"></i>
            <span>管理中心</span>
          </template>
          <el-menu-item-group style=" width: 166px; ">
            <el-menu-item index="/myclass" style="color: #333;">班级管理</el-menu-item>
            <el-menu-item index="/tiKu" style="color: #333;">考核管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>


        <el-submenu index="personalCenter" class="noborder" v-if=" roles != 'student' && roles != '学生'&& roles != 'visiter'"
          :class="{ active: isActive == '/huifu' || isActive == '/tongzh' || isActive == '/yuyue' || isActive == '/pinglu' || isActive == '/xinwen' }">
          <template slot="title">
            <i class="iconfont icon-xiaoxi" style="margin-right: 5px;"></i>
            <span>消息中心</span>
          </template>
          <el-menu-item-group style="width: 166px; border-top:none!important;">
            <el-menu-item index="/huifu" style="color: #333;">我的消息</el-menu-item>
            <el-menu-item index="/tongzhi" style="color: #333;" @click="totongzhi">通知公告</el-menu-item>
            <el-menu-item index="/yuyue" style="color: #333;">预约通知</el-menu-item>
            <el-menu-item index="/pinglun" style="color: #333;"
              v-if="roles != 'student' && roles != '学生'">评论审核</el-menu-item>
            <el-menu-item index="/xinwen" style="color: #333;" @click="toxinwen">新闻资讯</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

      </el-menu>
      <!-- 头像 -->
      <div class="grid-content bg-purple-light">
        <el-row class="demo-avatar demo-basic">
          <div class="demo-basic--circle" style="display: flex; justify-content: space-around;">
            <div>
            </div>

            <div style="display: flex;align-items: center;">
              <el-dropdown :hide-on-click="false" v-if="username != '游客账号'">
                <div class="demo-basic--circle">
                  <div style="display: flex;align-items: center;margin-top: -10px;">
                    <img :src=avatar alt="" style="width: 40px;margin-top: 10px;margin-right: 30px;"
                      v-if="avatar != ''">
                    <img src="../../assets/f3016683d4c3591fb738bade50401c8.png" alt=""
                      style="width: 40px;margin-top: 10px;margin-right: 30px;" v-if="avatar == '' && sex == 0">
                    <img src="../../assets/946d47910caf603079fabda3edce8e7.png" alt=""
                      style="width: 40px;margin-top: 10px;margin-right: 30px;" v-if="avatar == '' && sex != 0">
                  </div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><i class="el-icon-info"></i><span
                      @click="toadminBox()">个人中心</span></el-dropdown-item>
                  <el-dropdown-item><i class="el-icon-switch-button"></i><span @click="LogOut()">退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div style="line-height: 7vh;margin-left: -15px;white-space: nowrap; color: #fff;" class="adminnamebox">
                <span v-if="username != '游客账号'">{{ username }}</span>
                <span v-if="username == '游客账号'" class="login_btn" @click="tologin_box">
                  <div class="cover_box">
                    <i class="el-icon-user-solid"></i>
                  </div> 登录
                </span>
                <!-- <span v-if="usertype != 1">请登录</span> -->
                <i class="el-icon-s-fold" @click="drawer = true"></i>

                <!-- <div style="line-height: 7vh;margin-left: -15px;white-space: nowrap; color: #fff;" class="adminnamebox">
                <span>游客账号</span> -->
              </div>
            </div>
          </div>
        </el-row>
      </div>
    </div>
    <el-drawer :modal="false" title="导航栏" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
      style="z-index: 1;" class="phonenav">
      <el-menu :default-active="this.$route.path" router background-color="transparent" class="el-menu-demo"
        text-color="#999" active-text-color="#fff" style="" mode="vertical">
        <el-menu-item index="/homepage">
          <i class="iconfont icon-shouye" style="margin-right: 5px;"></i>
          <span slot="title">首页 </span>
        </el-menu-item>
        <el-menu-item index="/shouye"
          :class="{ active: isActive == '/shouye' || isActive == '/bianji' || isActive == '/tongji' || isActive == '/jilu' || isActive == '/shiyan' || isActive == '/expbia' }">
          <i class="iconfont icon-shiyan" style="margin-right: 5px;"></i>
          <span slot="title" v-if="roles != 'student' && roles != '学生' && roles != 'visiter'">实验中心</span>
          <span slot="title" v-if=" roles == 'visiter'">实验课程</span>
        </el-menu-item>
        <el-menu-item index="/videopage"
          :class="{ active: isActive == '/videob' || isActive == '/videox' || isActive == '/online' || isActive == '/videoc' }">
          <i class="iconfont icon-shipin" style="margin-right: 5px;"></i>
          <span slot="title" v-if="roles != 'student' && roles != '学生' && roles != 'visiter'">课程中心</span>
          <span slot="title" v-if=" roles == 'visiter'">在线课程</span>
        </el-menu-item>

        <el-submenu index="5" :class="{ active: isActive == '/Resour' || isActive == '/videor' }"
          v-if="roles != 'student' && roles != '学生' && roles != 'visiter'" class="noborder">
          <template slot="title">
            <i class="iconfont icon-guizewendang" style="margin-right: 5px;"></i>
            <span>资源中心</span>
          </template>
          <el-menu-item-group style="background: rgba(250, 250, 250, 1);  width: 166px;">
            <el-menu-item index="/Resources" style="color: #333;">实验资源</el-menu-item>
            <el-menu-item index="/videores" style="color: #333;">课程资源</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2"
          :class="{ active: isActive == '/myclas' || isActive == '/tiKu' || isActive == '/tiKu' || isActive == '/shijua' || isActive == '/kaoshi' || isActive == '/chengj' }"
          v-if="roles != 'student' && roles != '学生' && roles != 'visiter'" class="noborder">
          <template slot="title">
            <i class="iconfont icon-renyuan-" style="margin-right: 5px;"></i>
            <span>管理中心</span>
          </template>
          <el-menu-item-group style=" width: 166px; ">
            <el-menu-item index="/myclass" style="color: #333;">班级管理</el-menu-item>
            <el-menu-item index="/tiKu" style="color: #333;">考核管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <!-- <el-menu-item index="/student_assess" v-if="roles == 'student' || roles == '学生'"
          :class="{ active: isActive == '/huifu' || isActive == '/tongzh' || isActive == '/yuyue' }">
          <i class="el-icon-tickets"></i>
          <span slot="title">考核中心</span>
        </el-menu-item> -->

        <el-submenu index="personalCenter" class="noborder" 
          :class="{ active: isActive == '/huifu' || isActive == '/tongzh' || isActive == '/yuyue' || isActive == '/pinglu' || isActive == '/xinwen' }">
          <template slot="title">
            <i class="iconfont icon-xiaoxi" style="margin-right: 5px;"></i>
            <span>消息中心 </span>
          </template>
          <el-menu-item-group style="width: 166px; border-top:none!important;">
            <el-menu-item index="/huifu" style="color: #333;">我的消息</el-menu-item>
            <el-menu-item index="/tongzhi" style="color: #333;" @click="totongzhi">通知公告</el-menu-item>
            <el-menu-item index="/yuyue" style="color: #333;">预约通知</el-menu-item>
            <el-menu-item index="/pinglun" style="color: #333;"
              v-if="roles != 'student' && roles != '学生'">评论审核</el-menu-item>
            <el-menu-item index="/xinwen" style="color: #333;" @click="toxinwen">新闻资讯</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Logins } from "@/api/index.js"
import $ from 'jquery'
import axios from 'axios';
import { getUserInfo ,getTokenUserId} from "@/api/index.js";
import { Message } from 'element-ui';
export default {
  name: 'DingBu',
  data() {
    return {
      // avatar: localStorage.getItem('avatar'),
      //用户名
      // isActive: window.location.href.slice(26, 32),
      // isActive: window.location.href.split('/')[window.location.href.split('/').length - 1],
      isActive: this.$route.path,
      // username: localStorage.getItem('username'),
      // roles: localStorage.getItem('roles'),
      // sex: localStorage.getItem('sex'),
      usertype: localStorage.getItem('usertype'),
      drawer: false,
      direction: 'rtl',
    }
  },
  computed: {
    ...mapState(['username', 'roles', 'sex', 'avatar'])

  },
  created() {
    setTimeout(() => {
      // this.avatar = localStorage.getItem('avatar')
    }, 500);
    this.GetId()
    if (this.usertype != 1) {
      Logins({
        username: "20230000",
        password: "123456"
      }).then((res) => {
        if (res.data.code == 200) {
          localStorage.setItem('token', res.data.token);
          this.GetId()
        } else {

        }
      })
    }
  },
  mounted() {
    // console.log(this.isActive);

  },
  methods: {
    tologin_box() {
      this.$router.push({
        path: '/Loginpage',
        query: { redirect: this.$route.fullPath }
      })
    },
    handleClose(done) {
      done();
    },
    totongzhi() {
      localStorage.removeItem('inform')
    },
    toxinwen() {
      localStorage.removeItem('news')
    },
    GetId() {
      getTokenUserId().then((res) => {
        if (res.data.code == 200) {
          console.log('res.data1',res.data);
          // console.log(res.data,'res.data');
          localStorage.setItem('username', res.data.user.nickName);
          localStorage.setItem('userId', res.data.user.userId);
          localStorage.setItem('classId', res.data.classId);
          localStorage.setItem('roles', res.data.user.remark);
          localStorage.setItem('sex', res.data.user.sex);
          localStorage.setItem('avatar', res.data.user.avatar);
          this.$store.dispatch('updateUsername',res.data.user.nickName)
          this.$store.dispatch('updateRoles',res.data.user.remark)
          this.$store.dispatch('updateSex',res.data.user.sex)
          this.$store.dispatch('updateAvatar',res.data.user.avatar)
          this.getadmin(res.data.user.userId)
        } else {
          this.usertype = 2
          Logins({
            username: "20230000",
            password: "123456"
          }).then((res) => {
            if (res.data.code == 200) {
              localStorage.setItem('token', res.data.token);
              this.GetId()
            } else {

            }
          })
        }

        //跳转页面
        // this.$router.push('/homepage')

      })
    },
    getadmin(data) {
      getUserInfo(data).then(res => {
        if (res.data.code == 200) {
          console.log('res.data2',res.data);
          localStorage.setItem('avatar', res.data.data.avatar)
          // console.log(res.data.data);
          
          this.$store.dispatch('updateAvatar',res.data.data.avatar)
        }
      })

    },
    //  退出登录
    LogOut() {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.getItem('usertype', 1)
      this.$store.dispatch('updateUsername', "游客账号")
      this.$store.dispatch('updateRoles', "visiter")
      this.$store.dispatch('updateSex', "0")
      this.$store.dispatch('updateAvatar', "")
      Message({
        message: '退出登录成功',
        type: 'success'
      });
      this.$router.push('/Loginpage')
    },
    // 点击跳转个人中心
    toadminBox() {
      this.$router.push({
        path: '/personalCenter',
      })

    }
  },

}
</script>

<style scoped>
.outbig_box .el-menu--horizontal>.el-menu-item.is-active {
  border-top: 3px solid #0958d9 !important;
  border-bottom: none
}

.outbig_box {
  background-size: 100% 100%;
  /* background-color: #fff; */
  background-color: rgba(0, 0, 0, 1);
  height: 72px;
  position: relative;
  z-index: 22;
}

.active {
  /* border-top: 3px solid #0958d9 !important; */
}


.navbox {
  display: flex;
  justify-content: space-between;
  max-width: 1600px;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  height: 72px;

}

el-col {
  border-radius: 4px;
}

.el-menu.el-menu--horizontal {
  overflow: hidden;
  height: 100%;
}

.el-menu.el-menu--horizontal>li {
  display: flex;
  align-items: center;
  height: 100%;
}

.grid-content {
  min-height: 36px;
  display: flex;
  align-items: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}

/*设定头像图片样式*/
.avatar-info {
  margin-top: 10px;
  margin-right: 40px;
  cursor: pointer;
}

.zhu {
  margin-left: 10%;
  margin-right: 10%;
}

/* 左侧导航栏样式 */
.scrollbar-wrapper {
  height: 100%;
  overflow-x: hidden !important;
}

.block {
  float: right;
  margin-right: 3vw;
  margin-top: 2vh;
}
</style>
<style lang="scss">
.outbig_box {
  .el-dropdown {
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
}

.el-menu--horizontal>.el-menu-item {
  border-bottom: none !important;
  border-top: 3px solid transparent;
}

.el-menu--popup-bottom-start {
  box-shadow: none !important;
  background-color: rgba(250, 250, 250, 0.8) !important;

  .el-menu-item:hover {
    background-color: #277aff !important;
    color: #fff !important;

  }

  .el-menu-item {
    height: 70px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;

  }

}

.el-menu--popup {
  box-shadow: none;
  min-width: none !important;
  box-shadow: 2px 3px 8px 0px rgba(0, 0, 0, 0.3) !important;
  background-color: rgba(250, 250, 250, 0.8) !important;
}


.navbox .el-menu.el-menu--horizontal>li:hover {
  background-color: #0958d9 !important;
  // border-top:5px solid #277aff !important;
}

.navbox .el-submenu__title * {
  font-size: 18px !important;
}


.navbox .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #0958d9 !important;

}

.navbox .el-menu-item * {
  font-size: 18px !important;
}

.navbox .el-submenu {
  line-height: 60px;
  box-sizing: border-box;
  border-top: 3px solid transparent;
  padding-bottom: 3px;
}

.navbox .el-menu.el-menu--horizontal {
  i {
    color: #fff;
  }

  border: none;
}

// .navbox .el-menu--horizontal>.el-menu-item:hover {}

.navbox .el-menu--popup {
  box-shadow: none !important;
  ;
}

.el-menu-item-group__title {
  display: none !important;
  ;
}

.el-menu-item:hover {
  background-color: #355af0a2 !important;
}

.noborder .el-submenu__title {
  border: none !important;
}

.el-menu--popup {
  min-width: 0px !important;
  width: 166px !important;
}
</style>
<style lang="scss" scoped>
.phonenav {
  display: none;
}

@media (max-width:550px) {
  .adminnamebox {
    display: flex;
    align-items: center;

    .login_btn {
      padding: 0 !important;
    }

    i {
      display: block !important;
    }
  }

  .outbig_box {
    height: 50px;

    >.navbox {
      height: 50px;

      >div:first-child {
        >img {
          height: 25px !important;
        }

        >span {
          font-size: 16px !important;
        }
      }

      >div:last-child {
        .adminnamebox {
          font-size: 12px;
        }

        img {
          width: 25px !important;
          height: 25px;
          margin-right: 20px !important;
        }

        i {
          // margin-left: 10px;
          font-size: 16px;
        }
      }

    }
  }



}
</style>
<style lang="scss" scoped>
@media (max-width:550px) {
  .navbox .el-menu.el-menu--horizontal {
    display: none;
  }

  .phonenav {
    display: block;
  }

  .v-modal {
    z-index: 1 !important;
  }

  .el-menu-item:hover {
    color: #fff !important;

    i {
      color: #fff !important;

    }
  }

  .el-menu-item [class^="el-icon-"] {
    width: 18px !important;
  }

  .el-menu-item.is-active {
    background-color: #0958d9 !important;
  }

  .el-drawer__open .el-drawer.rtl {
    z-index: 999 !important;
    position: relative;
  }
}
</style>
<style lang="scss" scoped>
.login_btn {
  padding: 5px 30px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;

  >.cover_box {
    padding: 10px;
    border-radius: 50%;
    background-color: red;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2B2A33;
    margin-right: 15px
  }
}

.login_btn:hover {
  color: #0958D9;
}

.adminnamebox {
  .cover_box {
    i {
      display: block;
    }
  }

  i {
    display: none;
  }
}
</style>
